import { Routes, Route, Navigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { authApi, getAccessToken } from './api/client'
import Layout from './components/Layout/Layout'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Devices from './pages/Devices'
import DeviceDetail from './pages/DeviceDetail'
import Tunnels from './pages/Tunnels'
import Enroll from './pages/Enroll'
import Settings from './pages/Settings'
import Relays from './pages/Relays'
import { AuthContext, useAuth } from './context/AuthContext'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { operator, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    )
  }

  if (!operator) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  const { data: operator, isLoading, refetch } = useQuery({
    queryKey: ['currentUser'],
    queryFn: authApi.getCurrentUser,
    enabled: !!getAccessToken(),
    retry: false,
  })

  return (
    <AuthContext.Provider value={{ operator: operator ?? null, isLoading, refetch }}>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="devices" element={<Devices />} />
          <Route path="devices/:id" element={<DeviceDetail />} />
          <Route path="tunnels" element={<Tunnels />} />
          <Route path="enroll" element={<Enroll />} />
          <Route path="relays" element={<Relays />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </AuthContext.Provider>
  )
}

export default App
